import React, { FC, PropsWithChildren } from 'react';
import { genericMemo } from '@direct-frontend/stdlib';

import { Badge } from '../../Badge';
import './UserBarNotification.css';
import { cn } from '../../../lib/css/className/className';
import { HStack } from '../../Stack';
import { TestProps } from '../../../internal/types/testTypes';

export type UserBarNotificationProps = PropsWithChildren<{
    /**
     * количество уведомлений
     */
    counter?: number;
    /**
     * Цвет бейджа уведомления
     */
    color?: 'blue' | 'yellow';
}> &
    TestProps;

const cnUserBarNotification = cn('UserBarNotification');

/**
 *  Компонент-обертка над иконкой для отображения наличия и колличества уведомлений
 */
export const UserBarNotification: FC<UserBarNotificationProps> = genericMemo(function UserBarNotification({
    children,
    counter,
    'data-testid': dataTestId,
    color = 'blue',
}) {
    let handledCounter;

    if (counter) {
        handledCounter = Math.min(counter, 99);
    }

    const content = (
        <HStack className={cnUserBarNotification('')}>
            {children}

            <Badge
                className={cnUserBarNotification('badge')}
                data-testid={`${dataTestId ?? 'UserBarNotification'}.Badge`}
                color={color}
                size="16"
            >
                {handledCounter}
            </Badge>
        </HStack>
    );

    return (
        <HStack alignItems="center" className={cnUserBarNotification('layout')}>
            {content}
        </HStack>
    );
});
